// Company Roadmap Timeline Dataset
// One year of data with events spanning across several weeks/months
// Resources are the various teams

// Timeline starts July 1, 2025
export const defaultVisibleDate = new Date('2025-07-01T00:00:00');

export const resources = [
  { title: 'Product', id: 'product', eventColor: 'purple' },
  { title: 'Design', id: 'design', eventColor: 'pink' },
  { title: 'Engineering', id: 'engineering', eventColor: 'blue' },
  { title: 'QA', id: 'qa', eventColor: 'teal' },
  { title: 'DevOps', id: 'devops', eventColor: 'green' },
  { title: 'Marketing', id: 'marketing', eventColor: 'orange' },
  { title: 'Sales', id: 'sales', eventColor: 'lime' },
  { title: 'Customer Success', id: 'customer-success', eventColor: 'indigo' },
  { title: 'HR', id: 'hr', eventColor: 'red' },
  { title: 'Finance', id: 'finance', eventColor: 'grey' },
];

export const initialEvents = [
  // ============================================
  // PRODUCT TEAM (25 events)
  // ============================================
  // Q3 Planning Phase (July)
  {
    id: 'product-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-05T00:00:00',
    title: 'Q3 Strategic Planning',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-2',
    start: '2025-07-07T00:00:00',
    end: '2025-07-11T00:00:00',
    title: 'Roadmap Review & Prioritization',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-3',
    start: '2025-07-14T00:00:00',
    end: '2025-07-18T00:00:00',
    title: 'Customer Research Synthesis',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-4',
    start: '2025-07-21T00:00:00',
    end: '2025-07-31T00:00:00',
    title: 'Feature Specification: Analytics Dashboard',
    resource: 'product',
    allDay: true,
  },
  // Q3 Execution (August-September)
  {
    id: 'product-5',
    start: '2025-08-01T00:00:00',
    end: '2025-08-15T00:00:00',
    title: 'Mobile App PRD',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-6',
    start: '2025-08-18T00:00:00',
    end: '2025-09-05T00:00:00',
    title: 'API V3 Specification',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-7',
    start: '2025-09-08T00:00:00',
    end: '2025-09-19T00:00:00',
    title: 'Integration Partners Requirements',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-8',
    start: '2025-09-22T00:00:00',
    end: '2025-09-30T00:00:00',
    title: 'Q4 Planning Preparation',
    resource: 'product',
    allDay: true,
  },
  // Q4 Planning (October)
  {
    id: 'product-9',
    start: '2025-10-01T00:00:00',
    end: '2025-10-10T00:00:00',
    title: 'Q4 Strategic Planning',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-10',
    start: '2025-10-14T00:00:00',
    end: '2025-10-25T00:00:00',
    title: 'Annual Review Documentation',
    resource: 'product',
    allDay: true,
  },
  // Q4 Execution (November-December)
  {
    id: 'product-11',
    start: '2025-11-01T00:00:00',
    end: '2025-11-14T00:00:00',
    title: 'Enterprise Features PRD',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-12',
    start: '2025-11-17T00:00:00',
    end: '2025-12-06T00:00:00',
    title: 'Security Audit Planning',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-13',
    start: '2025-12-09T00:00:00',
    end: '2025-12-20T00:00:00',
    title: '2026 Roadmap Draft',
    resource: 'product',
    allDay: true,
  },
  // Q1 2026 (January-March)
  {
    id: 'product-14',
    start: '2026-01-06T00:00:00',
    end: '2026-01-17T00:00:00',
    title: 'Q1 Kickoff & Goal Setting',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-15',
    start: '2026-01-20T00:00:00',
    end: '2026-02-07T00:00:00',
    title: 'AI Features Specification',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-16',
    start: '2026-02-10T00:00:00',
    end: '2026-02-28T00:00:00',
    title: 'Platform Redesign PRD',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-17',
    start: '2026-03-03T00:00:00',
    end: '2026-03-14T00:00:00',
    title: 'Accessibility Audit Review',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-18',
    start: '2026-03-17T00:00:00',
    end: '2026-03-28T00:00:00',
    title: 'Performance Benchmarks',
    resource: 'product',
    allDay: true,
  },
  // Q2 2026 (April-June)
  {
    id: 'product-19',
    start: '2026-04-01T00:00:00',
    end: '2026-04-11T00:00:00',
    title: 'Q2 Planning Sprint',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-20',
    start: '2026-04-14T00:00:00',
    end: '2026-04-30T00:00:00',
    title: 'Customer Advisory Board Prep',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-21',
    start: '2026-05-01T00:00:00',
    end: '2026-05-15T00:00:00',
    title: 'Marketplace Strategy',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-22',
    start: '2026-05-18T00:00:00',
    end: '2026-05-31T00:00:00',
    title: 'Self-Service Portal PRD',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-23',
    start: '2026-06-01T00:00:00',
    end: '2026-06-12T00:00:00',
    title: 'Analytics Revamp Planning',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-24',
    start: '2026-06-15T00:00:00',
    end: '2026-06-25T00:00:00',
    title: 'H2 2026 Roadmap',
    resource: 'product',
    allDay: true,
  },
  {
    id: 'product-25',
    start: '2026-06-26T00:00:00',
    end: '2026-06-30T00:00:00',
    title: 'Mid-Year Review',
    resource: 'product',
    allDay: true,
  },
  // ============================================
  // DESIGN TEAM (15 events)
  // ============================================
  {
    id: 'design-1',
    start: '2025-07-08T00:00:00',
    end: '2025-07-26T00:00:00',
    title: 'Dashboard Redesign',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-2',
    start: '2025-08-04T00:00:00',
    end: '2025-08-29T00:00:00',
    title: 'Mobile App UI/UX',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-3',
    start: '2025-09-01T00:00:00',
    end: '2025-09-12T00:00:00',
    title: 'Design System Update V2',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-4',
    start: '2025-09-15T00:00:00',
    end: '2025-10-04T00:00:00',
    title: 'Onboarding Flow Redesign',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-5',
    start: '2025-10-07T00:00:00',
    end: '2025-10-18T00:00:00',
    title: 'Icon Library Refresh',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-6',
    start: '2025-10-21T00:00:00',
    end: '2025-11-08T00:00:00',
    title: 'Enterprise Theme',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-7',
    start: '2025-11-11T00:00:00',
    end: '2025-11-29T00:00:00',
    title: 'Dark Mode Implementation',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-8',
    start: '2025-12-01T00:00:00',
    end: '2025-12-19T00:00:00',
    title: 'Accessibility Improvements',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-9',
    start: '2026-01-06T00:00:00',
    end: '2026-01-24T00:00:00',
    title: 'Component Library V3',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-10',
    start: '2026-02-03T00:00:00',
    end: '2026-02-21T00:00:00',
    title: 'Admin Panel Redesign',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-11',
    start: '2026-03-01T00:00:00',
    end: '2026-03-14T00:00:00',
    title: 'Email Templates',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-12',
    start: '2026-04-07T00:00:00',
    end: '2026-04-25T00:00:00',
    title: 'Marketing Website Refresh',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-13',
    start: '2026-05-01T00:00:00',
    end: '2026-05-19T00:00:00',
    title: 'Illustration Library',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-14',
    start: '2026-05-22T00:00:00',
    end: '2026-06-07T00:00:00',
    title: 'Motion Design Guidelines',
    resource: 'design',
    allDay: true,
  },
  {
    id: 'design-15',
    start: '2026-06-10T00:00:00',
    end: '2026-06-28T00:00:00',
    title: 'Brand Evolution',
    resource: 'design',
    allDay: true,
  },
  // ============================================
  // ENGINEERING TEAM (20 events)
  // ============================================
  {
    id: 'eng-1',
    start: '2025-07-01T00:00:00',
    end: '2025-08-15T00:00:00',
    title: 'Analytics Dashboard Development',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-2',
    start: '2025-08-18T00:00:00',
    end: '2025-09-30T00:00:00',
    title: 'Mobile App Backend',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-3',
    start: '2025-10-01T00:00:00',
    end: '2025-10-31T00:00:00',
    title: 'API V3 Development',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-4',
    start: '2025-11-01T00:00:00',
    end: '2025-11-21T00:00:00',
    title: 'Performance Optimization Sprint',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-5',
    start: '2025-11-24T00:00:00',
    end: '2025-12-20T00:00:00',
    title: 'Security Hardening',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-6',
    start: '2026-01-06T00:00:00',
    end: '2026-02-14T00:00:00',
    title: 'Platform Rewrite Phase 1',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-7',
    start: '2026-02-17T00:00:00',
    end: '2026-03-28T00:00:00',
    title: 'Platform Rewrite Phase 2',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-8',
    start: '2026-04-01T00:00:00',
    end: '2026-04-30T00:00:00',
    title: 'AI Feature Integration',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-9',
    start: '2026-05-01T00:00:00',
    end: '2026-05-31T00:00:00',
    title: 'Marketplace Development',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-10',
    start: '2026-06-01T00:00:00',
    end: '2026-06-30T00:00:00',
    title: 'Self-Service Portal',
    resource: 'engineering',
    allDay: true,
  },
  // Shorter engineering tasks (overlapping)
  {
    id: 'eng-11',
    start: '2025-07-15T00:00:00',
    end: '2025-07-22T00:00:00',
    title: 'Technical Debt Sprint',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-12',
    start: '2025-08-01T00:00:00',
    end: '2025-08-07T00:00:00',
    title: 'Code Review Week',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-13',
    start: '2025-09-08T00:00:00',
    end: '2025-09-15T00:00:00',
    title: 'Documentation Sprint',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-14',
    start: '2025-10-14T00:00:00',
    end: '2025-10-21T00:00:00',
    title: 'Hackathon Week',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-15',
    start: '2025-12-01T00:00:00',
    end: '2025-12-07T00:00:00',
    title: 'Tech Stack Evaluation',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-16',
    start: '2026-01-13T00:00:00',
    end: '2026-01-20T00:00:00',
    title: 'Migration Planning',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-17',
    start: '2026-03-15T00:00:00',
    end: '2026-03-22T00:00:00',
    title: 'Load Testing',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-18',
    start: '2026-04-14T00:00:00',
    end: '2026-04-21T00:00:00',
    title: 'Dependency Updates',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-19',
    start: '2026-05-10T00:00:00',
    end: '2026-05-17T00:00:00',
    title: 'CI/CD Improvements',
    resource: 'engineering',
    allDay: true,
  },
  {
    id: 'eng-20',
    start: '2026-06-15T00:00:00',
    end: '2026-06-22T00:00:00',
    title: 'Year-End Code Freeze',
    resource: 'engineering',
    allDay: true,
  },
  // ============================================
  // QA TEAM (12 events)
  // ============================================
  {
    id: 'qa-1',
    start: '2025-07-21T00:00:00',
    end: '2025-08-07T00:00:00',
    title: 'Analytics Dashboard Testing',
    resource: 'qa',
    allDay: true,
  },
  {
    id: 'qa-2',
    start: '2025-08-25T00:00:00',
    end: '2025-09-14T00:00:00',
    title: 'Mobile App Testing',
    resource: 'qa',
    allDay: true,
  },
  {
    id: 'qa-3',
    start: '2025-09-22T00:00:00',
    end: '2025-10-07T00:00:00',
    title: 'API V3 Testing',
    resource: 'qa',
    allDay: true,
  },
  {
    id: 'qa-4',
    start: '2025-10-21T00:00:00',
    end: '2025-11-04T00:00:00',
    title: 'Integration Testing Phase',
    resource: 'qa',
    allDay: true,
  },
  {
    id: 'qa-5',
    start: '2025-11-14T00:00:00',
    end: '2025-11-28T00:00:00',
    title: 'Security Testing',
    resource: 'qa',
    allDay: true,
  },
  {
    id: 'qa-6',
    start: '2025-12-08T00:00:00',
    end: '2025-12-22T00:00:00',
    title: 'Regression Testing',
    resource: 'qa',
    allDay: true,
  },
  {
    id: 'qa-7',
    start: '2026-01-27T00:00:00',
    end: '2026-02-10T00:00:00',
    title: 'Platform V2 Testing',
    resource: 'qa',
    allDay: true,
  },
  {
    id: 'qa-8',
    start: '2026-03-01T00:00:00',
    end: '2026-03-14T00:00:00',
    title: 'Performance Testing',
    resource: 'qa',
    allDay: true,
  },
  {
    id: 'qa-9',
    start: '2026-03-22T00:00:00',
    end: '2026-04-07T00:00:00',
    title: 'AI Feature Testing',
    resource: 'qa',
    allDay: true,
  },
  {
    id: 'qa-10',
    start: '2026-04-21T00:00:00',
    end: '2026-05-07T00:00:00',
    title: 'Marketplace Testing',
    resource: 'qa',
    allDay: true,
  },
  {
    id: 'qa-11',
    start: '2026-05-21T00:00:00',
    end: '2026-06-07T00:00:00',
    title: 'Self-Service Portal Testing',
    resource: 'qa',
    allDay: true,
  },
  {
    id: 'qa-12',
    start: '2026-06-14T00:00:00',
    end: '2026-06-28T00:00:00',
    title: 'Year-End Release Testing',
    resource: 'qa',
    allDay: true,
  },
  // ============================================
  // DEVOPS TEAM (10 events)
  // ============================================
  {
    id: 'devops-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-14T00:00:00',
    title: 'Infrastructure Assessment',
    resource: 'devops',
    allDay: true,
  },
  {
    id: 'devops-2',
    start: '2025-08-01T00:00:00',
    end: '2025-08-21T00:00:00',
    title: 'Kubernetes Migration',
    resource: 'devops',
    allDay: true,
  },
  {
    id: 'devops-3',
    start: '2025-09-01T00:00:00',
    end: '2025-09-14T00:00:00',
    title: 'CI/CD Pipeline Overhaul',
    resource: 'devops',
    allDay: true,
  },
  {
    id: 'devops-4',
    start: '2025-10-01T00:00:00',
    end: '2025-10-21T00:00:00',
    title: 'Monitoring & Alerting Setup',
    resource: 'devops',
    allDay: true,
  },
  {
    id: 'devops-5',
    start: '2025-11-01T00:00:00',
    end: '2025-11-14T00:00:00',
    title: 'Disaster Recovery Planning',
    resource: 'devops',
    allDay: true,
  },
  {
    id: 'devops-6',
    start: '2025-12-01T00:00:00',
    end: '2025-12-21T00:00:00',
    title: 'Security Infrastructure',
    resource: 'devops',
    allDay: true,
  },
  {
    id: 'devops-7',
    start: '2026-02-01T00:00:00',
    end: '2026-02-28T00:00:00',
    title: 'Multi-Region Deployment',
    resource: 'devops',
    allDay: true,
  },
  {
    id: 'devops-8',
    start: '2026-04-01T00:00:00',
    end: '2026-04-14T00:00:00',
    title: 'Cost Optimization',
    resource: 'devops',
    allDay: true,
  },
  {
    id: 'devops-9',
    start: '2026-05-01T00:00:00',
    end: '2026-05-14T00:00:00',
    title: 'Auto-Scaling Implementation',
    resource: 'devops',
    allDay: true,
  },
  {
    id: 'devops-10',
    start: '2026-06-01T00:00:00',
    end: '2026-06-21T00:00:00',
    title: 'Infrastructure as Code',
    resource: 'devops',
    allDay: true,
  },
  // ============================================
  // MARKETING TEAM (12 events)
  // ============================================
  {
    id: 'marketing-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-21T00:00:00',
    title: 'Q3 Campaign Planning',
    resource: 'marketing',
    allDay: true,
  },
  {
    id: 'marketing-2',
    start: '2025-07-22T00:00:00',
    end: '2025-08-15T00:00:00',
    title: 'Product Launch: Analytics',
    resource: 'marketing',
    allDay: true,
  },
  {
    id: 'marketing-3',
    start: '2025-08-18T00:00:00',
    end: '2025-09-07T00:00:00',
    title: 'Conference Season Prep',
    resource: 'marketing',
    allDay: true,
  },
  {
    id: 'marketing-4',
    start: '2025-09-15T00:00:00',
    end: '2025-10-07T00:00:00',
    title: 'Mobile App Launch Campaign',
    resource: 'marketing',
    allDay: true,
  },
  {
    id: 'marketing-5',
    start: '2025-10-08T00:00:00',
    end: '2025-10-28T00:00:00',
    title: 'Q4 Campaign Planning',
    resource: 'marketing',
    allDay: true,
  },
  {
    id: 'marketing-6',
    start: '2025-11-01T00:00:00',
    end: '2025-11-28T00:00:00',
    title: 'Holiday Campaign',
    resource: 'marketing',
    allDay: true,
  },
  {
    id: 'marketing-7',
    start: '2025-12-01T00:00:00',
    end: '2025-12-14T00:00:00',
    title: 'Year-End Review',
    resource: 'marketing',
    allDay: true,
  },
  {
    id: 'marketing-8',
    start: '2026-01-06T00:00:00',
    end: '2026-01-28T00:00:00',
    title: 'Q1 2026 Planning',
    resource: 'marketing',
    allDay: true,
  },
  {
    id: 'marketing-9',
    start: '2026-02-01T00:00:00',
    end: '2026-02-21T00:00:00',
    title: 'Brand Refresh Campaign',
    resource: 'marketing',
    allDay: true,
  },
  {
    id: 'marketing-10',
    start: '2026-03-01T00:00:00',
    end: '2026-03-28T00:00:00',
    title: 'Spring Launch Campaign',
    resource: 'marketing',
    allDay: true,
  },
  {
    id: 'marketing-11',
    start: '2026-04-01T00:00:00',
    end: '2026-04-21T00:00:00',
    title: 'Partnership Announcements',
    resource: 'marketing',
    allDay: true,
  },
  {
    id: 'marketing-12',
    start: '2026-05-01T00:00:00',
    end: '2026-06-07T00:00:00',
    title: 'Annual Conference',
    resource: 'marketing',
    allDay: true,
  },
  // ============================================
  // SALES TEAM (10 events)
  // ============================================
  {
    id: 'sales-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-14T00:00:00',
    title: 'Q3 Quota Setting',
    resource: 'sales',
    allDay: true,
  },
  {
    id: 'sales-2',
    start: '2025-07-21T00:00:00',
    end: '2025-08-07T00:00:00',
    title: 'Enterprise Sales Training',
    resource: 'sales',
    allDay: true,
  },
  {
    id: 'sales-3',
    start: '2025-09-01T00:00:00',
    end: '2025-09-21T00:00:00',
    title: 'Partner Program Launch',
    resource: 'sales',
    allDay: true,
  },
  {
    id: 'sales-4',
    start: '2025-10-01T00:00:00',
    end: '2025-10-14T00:00:00',
    title: 'Q4 Quota Setting',
    resource: 'sales',
    allDay: true,
  },
  {
    id: 'sales-5',
    start: '2025-11-01T00:00:00',
    end: '2025-11-30T00:00:00',
    title: 'End of Year Push',
    resource: 'sales',
    allDay: true,
  },
  {
    id: 'sales-6',
    start: '2025-12-15T00:00:00',
    end: '2025-12-31T00:00:00',
    title: 'Year-End Deals Closing',
    resource: 'sales',
    allDay: true,
  },
  {
    id: 'sales-7',
    start: '2026-01-06T00:00:00',
    end: '2026-01-20T00:00:00',
    title: 'Q1 2026 Planning',
    resource: 'sales',
    allDay: true,
  },
  {
    id: 'sales-8',
    start: '2026-02-01T00:00:00',
    end: '2026-02-14T00:00:00',
    title: 'New Product Training',
    resource: 'sales',
    allDay: true,
  },
  {
    id: 'sales-9',
    start: '2026-04-01T00:00:00',
    end: '2026-04-14T00:00:00',
    title: 'Q2 Kickoff',
    resource: 'sales',
    allDay: true,
  },
  {
    id: 'sales-10',
    start: '2026-05-15T00:00:00',
    end: '2026-06-07T00:00:00',
    title: 'Annual Sales Summit',
    resource: 'sales',
    allDay: true,
  },
  // ============================================
  // CUSTOMER SUCCESS TEAM (8 events)
  // ============================================
  {
    id: 'cs-1',
    start: '2025-07-07T00:00:00',
    end: '2025-07-28T00:00:00',
    title: 'Onboarding Process Redesign',
    resource: 'customer-success',
    allDay: true,
  },
  {
    id: 'cs-2',
    start: '2025-08-01T00:00:00',
    end: '2025-08-21T00:00:00',
    title: 'Customer Health Score Implementation',
    resource: 'customer-success',
    allDay: true,
  },
  {
    id: 'cs-3',
    start: '2025-09-15T00:00:00',
    end: '2025-10-07T00:00:00',
    title: 'QBR Season',
    resource: 'customer-success',
    allDay: true,
  },
  {
    id: 'cs-4',
    start: '2025-11-01T00:00:00',
    end: '2025-11-21T00:00:00',
    title: 'Renewal Campaign',
    resource: 'customer-success',
    allDay: true,
  },
  {
    id: 'cs-5',
    start: '2025-12-15T00:00:00',
    end: '2026-01-07T00:00:00',
    title: 'Customer Advisory Board',
    resource: 'customer-success',
    allDay: true,
  },
  {
    id: 'cs-6',
    start: '2026-02-15T00:00:00',
    end: '2026-03-07T00:00:00',
    title: 'NPS Survey & Analysis',
    resource: 'customer-success',
    allDay: true,
  },
  {
    id: 'cs-7',
    start: '2026-04-15T00:00:00',
    end: '2026-05-07T00:00:00',
    title: 'Success Playbook Update',
    resource: 'customer-success',
    allDay: true,
  },
  {
    id: 'cs-8',
    start: '2026-06-01T00:00:00',
    end: '2026-06-21T00:00:00',
    title: 'Year-End Customer Appreciation',
    resource: 'customer-success',
    allDay: true,
  },
  // ============================================
  // HR TEAM (8 events)
  // ============================================
  {
    id: 'hr-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-21T00:00:00',
    title: 'Q3 Hiring Sprint',
    resource: 'hr',
    allDay: true,
  },
  {
    id: 'hr-2',
    start: '2025-08-01T00:00:00',
    end: '2025-08-14T00:00:00',
    title: 'Performance Review Cycle',
    resource: 'hr',
    allDay: true,
  },
  {
    id: 'hr-3',
    start: '2025-09-15T00:00:00',
    end: '2025-10-07T00:00:00',
    title: 'Benefits Open Enrollment',
    resource: 'hr',
    allDay: true,
  },
  {
    id: 'hr-4',
    start: '2025-11-01T00:00:00',
    end: '2025-11-14T00:00:00',
    title: 'Compensation Review',
    resource: 'hr',
    allDay: true,
  },
  {
    id: 'hr-5',
    start: '2025-12-01T00:00:00',
    end: '2025-12-14T00:00:00',
    title: 'Year-End Bonuses',
    resource: 'hr',
    allDay: true,
  },
  {
    id: 'hr-6',
    start: '2026-01-13T00:00:00',
    end: '2026-02-07T00:00:00',
    title: 'Q1 2026 Hiring',
    resource: 'hr',
    allDay: true,
  },
  {
    id: 'hr-7',
    start: '2026-03-01T00:00:00',
    end: '2026-03-21T00:00:00',
    title: 'Training & Development Program',
    resource: 'hr',
    allDay: true,
  },
  {
    id: 'hr-8',
    start: '2026-05-01T00:00:00',
    end: '2026-05-21T00:00:00',
    title: 'Employee Engagement Survey',
    resource: 'hr',
    allDay: true,
  },
  // ============================================
  // FINANCE TEAM (6 events)
  // ============================================
  {
    id: 'finance-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-14T00:00:00',
    title: 'Q2 Financial Close',
    resource: 'finance',
    allDay: true,
  },
  {
    id: 'finance-2',
    start: '2025-09-22T00:00:00',
    end: '2025-10-14T00:00:00',
    title: 'Q3 Financial Close',
    resource: 'finance',
    allDay: true,
  },
  {
    id: 'finance-3',
    start: '2025-11-01T00:00:00',
    end: '2025-11-21T00:00:00',
    title: 'Annual Budget Planning',
    resource: 'finance',
    allDay: true,
  },
  {
    id: 'finance-4',
    start: '2025-12-15T00:00:00',
    end: '2026-01-14T00:00:00',
    title: 'Year-End Financial Close',
    resource: 'finance',
    allDay: true,
  },
  {
    id: 'finance-5',
    start: '2026-01-27T00:00:00',
    end: '2026-02-14T00:00:00',
    title: 'Q1 2026 Budget Review',
    resource: 'finance',
    allDay: true,
  },
  {
    id: 'finance-6',
    start: '2026-03-22T00:00:00',
    end: '2026-04-14T00:00:00',
    title: 'Q1 2026 Financial Close',
    resource: 'finance',
    allDay: true,
  },
];
